<template>
  <div class="main-page">
    <div class="container">
      <app-bar
        title="Data Pasien"
        :previousLink="{ name: 'SelectPoli' }" />

      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <!-- Poli Card -->
              <div class="card border-0 mb-3" role="button" @click="goSelectPoli">
                <div class="card-body">
                  <div class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Poli</div>
                  <div v-if="loading.listPoli" class="d-flex align-items-center justify-content-between poli-skeleton">
                    <div class="me-3 flex-grow-1 w-100">
                      <div class="placeholder-glow">
                        <span class="placeholder placeholder-line bg-neutral-200 col-8 mb-2"></span>
                        <span class="placeholder placeholder-line bg-neutral-200 col-6"></span>
                      </div>
                    </div>
                    <div class="icon-rect d-flex align-items-center justify-content-center bg-neutral-200 rounded">
                      <span class="placeholder rounded d-block"></span>
                    </div>
                  </div>
                  <div v-else class="d-flex align-items-center justify-content-between">
                    <div class="me-3 flex-grow-1">
                      <div class="fw-700 fs-14 color-neutral-900">
                        {{ (selectedPoli && (selectedPoli.poli_header || selectedPoli.poli_nama)) || 'Pilih poli' }}
                        <span v-if="selectedPoli">({{ selectedPoli.poli_nama }})</span>
                      </div>
                      <div v-if="selectedPoli && selectedPoli.poli_deskripsi" class="fw-400 fs-12 color-neutral-600 mt-1">{{ selectedPoli.poli_deskripsi }}</div>
                    </div>
                    <div class="icon-rect d-flex align-items-center justify-content-center bg-neutral-200 rounded">
                      <img :src="(selectedPoli && selectedPoli.poli_icon) ? selectedPoli.poli_icon : require('@/assets/icon/empty.png')" alt="poli icon" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Cabang Card -->
              <div class="card border-0 mb-3" role="button" @click="goSelectBranch">
                <div class="card-body">
                  <div class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Cabang</div>
                  <div v-if="loading.listBranchPoli" class="branch rounded d-flex justify-content-between align-items-center py-2 branch-skeleton">
                    <div class="branch-group d-flex align-items-center w-100">
                      <div class="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-neutral-200">
                        <span class="placeholder rounded-circle d-block"></span>
                      </div>
                      <div class="branch-group-info d-flex flex-column ps-3 flex-grow-1">
                        <div class="placeholder-glow">
                          <span class="placeholder placeholder-line bg-neutral-200 col-6 mb-2"></span>
                          <span class="placeholder placeholder-line bg-neutral-200 col-9 mb-1"></span>
                          <span class="placeholder placeholder-line bg-neutral-200 col-4"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="branch rounded d-flex justify-content-between align-items-center py-2">
                    <div class="branch-group d-flex align-items-center">
                      <div class="icon-wrapper bg-neutral-200 d-flex align-items-center justify-content-center rounded-circle">
                        <img :src="require('@/assets/icon/location.png')" alt="" />
                      </div>
                      <div class="branch-group-info d-flex flex-column ps-3">
                        <p class="branch-name fw-bold fs-14 lh-18 color-neutral-900 mb-0">{{ selectedBranchPoli ? selectedBranchPoli.nama : 'Pilih cabang' }}</p>
                        <p class="branch-address fw-400 fs-12 lh-14 mb-0 color-neutral-600">{{ selectedBranchPoli ? selectedBranchPoli.alamat : 'Alamat cabang akan tampil di sini' }}</p>
                        <small class="branch-phone fw-400 fs-12 lh-14 color-neutral-600">{{ (selectedBranchPoli && selectedBranchPoli.tlp) ? selectedBranchPoli.tlp : '-' }}</small>
                      </div>
                    </div>
                    <i class="ri-arrow-right-s-line fs-20 color-neutral-600"></i>
                  </div>
                </div>
              </div>

              <!-- Dokter Card -->
              <div class="card border-0 mb-3" role="button" @click="goSelectDoctor">
                <div class="card-body">
                  <div class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Dokter</div>
                  <div v-if="loading.listDoctorPoli" class="list-group list-group-flush doctor-skeleton">
                    <div class="list-group-item py-2 px-0 d-flex align-items-center gap-3">
                      <div class="avatar flex-shrink-0 bg-neutral-200">
                        <span class="placeholder d-block w-100 h-100"></span>
                      </div>
                      <div class="flex-grow-1 text-start w-100">
                        <div class="placeholder-glow">
                          <span class="placeholder placeholder-line bg-neutral-200 col-5 mb-2"></span>
                          <span class="placeholder placeholder-line bg-neutral-200 col-3"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="list-group list-group-flush">
                    <div class="list-group-item py-2 px-0 d-flex align-items-center gap-3">
                      <div class="avatar flex-shrink-0">
                        <img :src="(selectedDoctorPoli && selectedDoctorPoli.foto_profile) || require('@/assets/user-placeholder.png')" alt="doctor" />
                      </div>
                      <div class="flex-grow-1 text-start">
                        <div class="fw-700 fs-14 color-neutral-900">{{ selectedDoctorPoli ? selectedDoctorPoli.nama_dokter : 'Pilih dokter' }}</div>
                        <div class="fw-400 fs-12 color-neutral-600 mt-1">{{ selectedDoctorPoli ? (selectedDoctorPoli.kode_dokter || '-') : '' }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-md-6">
              <!-- Nama Pasien Card -->
              <div class="card border-0 mb-3">
                <div class="card-body">
                  <div class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Nama Pasien</div>
                  <div class="input-group mb-3">
                    <router-link
                      class="w-100"
                      :to="{
                        query: { showPatient: !isPatientForMobileShown }
                      }">
                      <select
                        class="form-select select-patient color-neutral-900"
                        id="input-patient"
                        v-model="selectedPatientPoli.pas_nama"
                        name="patient"
                        rules="required">
                          <option selected disabled style="display: none; border: none">Pilih Pasien</option>
                      </select>
                    </router-link>
                  </div>
                  <div
                    class="initial d-flex align-items-center bg-neutral-100 mb-2">
                    <div class="initial-wrapper d-flex align-items-center justify-content-center bg-info-500 rounded-circle">
                      <span class="initial-value fw-400 fs-14 lh-18 text-white">
                        {{ getInitialName(selectedPatientPoli.pas_nama) }}
                      </span>
                    </div>
                    <div class="value-wrapper d-flex flex-column">
                      <span class="value-wrapper-name fw-700 fs-14 lh-18 color-neutral-900">{{ selectedPatientPoli.pas_nama }}</span>
                      <label class="value-wrapper-email fw-400 fs-12 lh-14 color-neutral-600">({{ selectedPatientPoli.pas_wa }})</label>
                    </div>
                  </div>
                  <div class="input-group">
                    <div class="form-check d-flex align-items-center">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck1"
                        v-model="useMyData"
                        @change="setMyData"
                      >
                      <label class="form-label pt-1 ms-2 mb-0 fw-400 fs-14 lh-18 color-neutral-900" for="exampleCheck1">Gunakan data saya</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tanggal Periksa Card -->
              <div class="card border-0 mb-3">
                <div class="card-body">
                  <div class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Tanggal Periksa</div>
                  <div class="input-group row-flex justify-content-between gap-1 position-relative date-picker-group" @click="openDatePicker">
                    <!-- Hidden native date input to power the picker -->
                    <input
                      ref="datePickerRef"
                      type="date"
                      class="position-absolute top-0 start-0 w-100 h-100 opacity-0 pe-none"
                      v-model="selectedDatePoli"
                      :min="todayYmd"
                    />

                    <div class="col-3" @click.stop="openDatePicker">
                      <input
                        type="text"
                        :value="dayValue"
                        readonly
                        class="form-control text-center"
                        placeholder="Tanggal"
                      />
                    </div>
                    <div class="col-5 position-relative" @click.stop="openDatePicker">
                      <input
                        type="text"
                        :value="monthValue"
                        readonly
                        class="form-control text-center"
                        placeholder="Bulan"
                      />
                      <span class="month-caret">▼</span>
                    </div>
                    <div class="col-3" @click.stop="openDatePicker">
                      <input
                        type="text"
                        :value="yearValue"
                        readonly
                        class="form-control text-center"
                        placeholder="Tahun"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Jam Tersedia Card (placeholder) -->
              <div class="card border-0 mb-3">
                <div class="card-body">
                  <div class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Jam Tersedia</div>
                  <div v-if="loading.listDoctorSchedulePoli" class="d-flex align-items-center gap-2">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <span class="fs-12 color-neutral-600">Memuat jadwal...</span>
                  </div>
                  <div v-else>
                    <div v-if="availableSchedules.length" class="d-flex flex-wrap gap-2">
                      <button
                        v-for="(item, index) in availableSchedules"
                        :key="`schedule-${item.id_app_poli_dokter_jadwal}-${index}`"
                        type="button"
                        class="badge rounded-pill border px-3 py-2 bg-light text-dark"
                        :class="selectedDoctorSchedulePoli && item.id_app_poli_dokter_jadwal === selectedDoctorSchedulePoli.id_app_poli_dokter_jadwal ? 'bg-primary text-white border-0' : ''"
                        @click="selectSchedule(item)">
                        {{ item.jam }}
                      </button>
                    </div>
                    <div v-else class="text-muted fs-12">Tidak ada jadwal tersedia pada tanggal ini.</div>
                  </div>
                </div>
              </div>

              <!-- Syarat & Ketentuan Card -->
              <div class="card border-0 mb-3" v-if="selectedDoctorPoli && selectedDoctorPoli.ketentuan">
                <div class="card-body">
                  <div class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Syarat & Ketentuan</div>
                  <div class="form-check d-flex align-items-center">
                    <input
                      class="form-check-input form-check-input-circle"
                      type="radio"
                      id="tosAgree"
                      name="tosAgree"
                      :checked="tosAccepted"
                      @click.prevent="onTosRadioClick"
                    >
                    <label class="form-label pt-1 ms-2 mb-0 fw-400 fs-14 lh-18 color-neutral-900" for="tosAgree">
                      Saya telah membaca dan menyetujui Syarat & Ketentuan layanan
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div :class="isPatientForMobileShown ? 'backdrop' : ''" @click="closePatient"/>
        <div
          :class="!isPatientForMobileShown ? 'd-none' : 'col-md-4'">
          <div class="card card-patient border-0">
              <div
                class="card-body p-0 d-flex flex-column overflow-y-auto"
                :class="{
                  'flex-row justify-content-between': !isPatientForMobileShown,
                  'flex-column': isPatientForMobileShown
                }">
                <div class="row d-md-none">
                  <div class="col d-flex justify-content-center pb-3">
                    <div class="tab bg-neutral-300" />
                  </div>
                </div>
                <div
                  class="patient-list py-md-2 p-0 pb-3"
                  :class="{
                    'd-md-inline d-none': !isPatientForMobileShown
                  }">
                  <div
                    v-for="anggotaKeluarga in listAnggotaKeluarga"
                    :key="anggotaKeluarga"
                    @click="setSelectMember(anggotaKeluarga)"
                    class="patient-item d-flex align-items-center"
                  >
                    <div class="patient-wrapper d-flex align-items-center justify-content-center bg-info-500 rounded-circle">
                      <span class="patient-value fw-400 fs-14 lh-18 text-white">
                        {{ getInitialName(anggotaKeluarga.anggota_nama) }}
                      </span>
                    </div>
                    <div class="value-wrapper d-flex flex-column">
                      <span class="value-wrapper-name fw-700 fs-14 lh-18 color-neutral-900">{{ anggotaKeluarga.anggota_nama }}</span>
                      <label class="value-wrapper-email fw-400 fs-12 lh-14 color-neutral-600">{{ anggotaKeluarga.nama_hubungan }} ({{ anggotaKeluarga.anggota_nowa }})</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <!-- divider -->
      <div class="d-md-none my-3 py-3"></div>
    </div>

    <AddPatient/>

    <!-- Bottom Action Bar -->
    <div class="bottom-bar pb-md-3 p-2 px-md-0">
      <div class="container">
        <div class="row">
          <div class="col-md-6 ms-md-auto">
            <button
              @click="submit"
              class="btn btn-orange text-white w-100 pt-2 pb-2"
              :class="{ disabled: continueDisabled }"
              :disabled="continueDisabled"
            >
              Lanjutkan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade"
    id="modal-confirmation"
    tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body text-center d-flex flex-column py-3">
            <h5 class="modal-title" id="exampleModalLabel">Konfirmasi</h5>
            <p v-for="confirmationMessage in confirmationMessages" :key="confirmationMessage.val">
              {{ confirmationMessage.val }}
            </p>
            <div class="group-button pb-2 pt-3">
              <button
                type="button"
                class="btn btn-secondary text-white w-25 me-1" data-bs-dismiss="modal">Tidak</button>
              <button
                @click="submit"
                type="button" class="btn text-white btn-danger w-25 ms-1">
                Ya
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->

  <!-- Modal TOS -->
  <div class="modal fade" id="modal-tos" tabindex="-1" aria-labelledby="modalTosLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalTosLabel">Syarat & Ketentuan</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <small class="text-muted">Silakan scroll sampai bagian paling bawah sebelum menyetujui.</small>
            <a v-if="tosUrl" :href="tosUrl" class="fs-12" target="_blank" rel="noopener">Buka di tab baru</a>
          </div>
          <iframe
            v-if="tosUrl"
            ref="tosIframeRef"
            class="tos-iframe w-100"
            :src="tosUrl"
            @load="onTosIframeLoad"
          ></iframe>
          <div v-if="tosUrl" class="text-center mt-2">
            <small class="text-muted">Jika tombol tetap tidak aktif, klik "Buka di tab baru" dan baca sampai selesai.</small>
          </div>
          <div v-else class="text-muted fs-12">Ketentuan tidak tersedia.</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="onTosModalClosed">Tutup</button>
          <button type="button" class="btn btn-primary" :disabled="!tosAcceptEnabled" @click="acceptTos">Setuju</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick, onMounted, ref, computed, watch } from 'vue'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import AddPatient from '@/components/home/service/covid/AddPatient'
import { user } from '@/core/auth'
import AppBar from '@/components/AppBar.vue'
import { showNotif } from '@/core/utility'
import { Modal } from 'bootstrap'
import { title } from '@/core/page'
import { getAnggotaKeluarga, listAnggotaKeluarga } from '@/core/anggotaKeluarga'
import { selectedPatientPoli, isSelfPatientPoli, loading, postRegisterPoli, selectedDatePoli, selectedPoli, selectedBranchPoli, selectedDoctorPoli, listDoctorSchedulePoli, getListDoctorSchedulePoli, selectedDoctorSchedulePoli, preselectPoliFromQuery, preselectBranchFromQuery, preselectDoctorFromQuery } from '@/core/poli'

let modal = null
let tosModal = null
let tosFallbackTimer = null
let tosPollInterval = null

export default {
  components: {
    AddPatient,
    AppBar
  },
  setup () {
    // Ambil list anggota
    onMounted(() => {
      getAnggotaKeluarga()
    })

    // Prepare variable
    const errorMessage = ref('')
    const router = useRouter()
    const route = useRoute()
    const confirmationMessages = ref([])
    const useMyData = ref(true)
    const isMobile = computed(() => window.screen.width <= 767)
    // TOS state
    const tosAccepted = ref(false)
    const tosAcceptEnabled = ref(false)
    const tosIframeRef = ref(null)

    // Prepare computed
    const subTotal = computed(() => {
      return 10
    })

    const total = computed(() => {
      return parseInt(subTotal.value)
    })

    const summaries = computed(() => {
      const temp = []
      return temp
    })

    const isPatientForMobileShown = computed(() => route.query.showPatient === 'true')

    const datePickerRef = ref(null)

    const toYmd = (dateObj) => {
      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0')
      const day = String(dateObj.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    const todayYmd = toYmd(new Date())

    // default to today if not set
    if (!selectedDatePoli.value) {
      selectedDatePoli.value = toYmd(new Date())
    }
    const tosUrl = computed(() => (selectedDoctorPoli.value && selectedDoctorPoli.value.ketentuan) ? selectedDoctorPoli.value.ketentuan : '')

    const openDatePicker = () => {
      if (!selectedDoctorPoli.value) {
        return showNotif({ status: 'error', message: 'Silakan pilih dokter terlebih dahulu' })
      }
      if (datePickerRef.value) {
        if (typeof datePickerRef.value.showPicker === 'function') {
          datePickerRef.value.showPicker()
        } else {
          datePickerRef.value.click()
        }
      }
    }

    const dayValue = computed(() => {
      if (!selectedDatePoli.value) return ''
      return String(new Date(selectedDatePoli.value).getDate()).padStart(2, '0')
    })

    const monthValue = computed(() => {
      if (!selectedDatePoli.value) return ''
      const monthIndex = new Date(selectedDatePoli.value).getMonth()
      const monthNames = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      return monthNames[monthIndex]
    })

    const yearValue = computed(() => {
      if (!selectedDatePoli.value) return ''
      return String(new Date(selectedDatePoli.value).getFullYear())
    })

    const getInitialName = (fullname) => {
      if (fullname) {
        const totalWord = fullname.split(' ').length
        const fullName = fullname.split('')

        // cek jumlah kata
        if (totalWord === 1) {
          const initials = fullName.shift().charAt(0)
          return initials.toUpperCase()
        }

        const initials = fullname.split(' ')[0][0] + fullname.split(' ')[1][0]
        return initials.toUpperCase()
      }

      return ''
    }

    onMounted(async () => {
      // Call preselects BEFORE registers watchers to avoid reset
      await preselectPoliFromQuery(route.query)
      await preselectBranchFromQuery(route.query)
      await preselectDoctorFromQuery(route.query)

      // load schedules on initial mount if prerequisites exist
      if (selectedDoctorPoli.value && selectedDatePoli.value && selectedBranchPoli.value && selectedPoli.value) {
        getListDoctorSchedulePoli()
      }

      // re-fetch schedules when date changes, and reset selected schedule
      watch(selectedDatePoli, (newDate) => {
        selectedDoctorSchedulePoli.value = null
        if (newDate && selectedDoctorPoli.value) {
          getListDoctorSchedulePoli()
        }
        // changing date should not affect tos acceptance, but ensure modal state clean
        tosAcceptEnabled.value = false
      })

      // re-fetch schedules when doctor changes
      watch(selectedDoctorPoli, (newDoctor) => {
        // whenever doctor changes, reset selected schedule
        selectedDoctorSchedulePoli.value = null
        tosAccepted.value = false
        if (newDoctor && selectedDatePoli.value) {
          getListDoctorSchedulePoli()
        }
      })

      // reset downstream selections when branch changes
      watch(selectedBranchPoli, (newBranch, oldBranch) => {
        if (newBranch !== oldBranch) {
          selectedDoctorPoli.value = null
          selectedDoctorSchedulePoli.value = null
          listDoctorSchedulePoli.value = []
        }
      })

      // reset downstream selections when poli changes
      watch(selectedPoli, (newPoli, oldPoli) => {
        if (newPoli !== oldPoli) {
          selectedBranchPoli.value = null
          selectedDoctorPoli.value = null
          selectedDoctorSchedulePoli.value = null
          listDoctorSchedulePoli.value = []
          tosAccepted.value = false
        }
      })

      nextTick(() => {
        modal = new Modal(
          document.querySelector('#modalAddPatient'), {
            backdrop: 'static'
          }
        )

        tosModal = new Modal(
          document.querySelector('#modal-tos'), {
            backdrop: 'static',
            keyboard: false
          }
        )

        if (route.query.modalPatient === 'show') {
          modal.show()
        }

        title.value = 'Checkout'
      })
    })

    onBeforeRouteLeave((to, from, next) => {
      if (to && to.name === 'Home') {
        selectedPoli.value = null
        selectedBranchPoli.value = null
        selectedDoctorPoli.value = null
        selectedDoctorSchedulePoli.value = null
        listDoctorSchedulePoli.value = []
        selectedDatePoli.value = null
        selectedPatientPoli.value = user.value
        isSelfPatientPoli.value = 1
      }
      next()
    })

    const submit = async () => {
      try {
        modal.hide()
        const result = await postRegisterPoli()
        router.push({
          name: 'SummaryPoli',
          query: {
            id_order: result?.kode_daftar
          }
        })
      } catch (error) {
        errorMessage.value = error.response.data.message
      }
    }

    const setupTosDetection = () => {
      tosAcceptEnabled.value = false
      // clear previous timers/intervals
      if (tosFallbackTimer) clearTimeout(tosFallbackTimer)
      if (tosPollInterval) clearInterval(tosPollInterval)
      try {
        const iframe = tosIframeRef.value
        if (!iframe) throw new Error('iframe not ready')
        const doc = iframe.contentDocument || iframe.contentWindow.document
        const win = iframe.contentWindow
        const handler = () => {
          try {
            const scrollTop = win.scrollY || doc.documentElement.scrollTop || doc.body.scrollTop
            const clientHeight = win.innerHeight || doc.documentElement.clientHeight
            const scrollHeight = doc.documentElement.scrollHeight || doc.body.scrollHeight
            if (scrollTop + clientHeight >= scrollHeight - 2) {
              tosAcceptEnabled.value = true
              win.removeEventListener('scroll', handler)
              win.removeEventListener('wheel', handler)
              if (tosPollInterval) clearInterval(tosPollInterval)
            }
          } catch (e) {
            // in case cross-origin suddenly blocks, rely on fallback
          }
        }
        win.addEventListener('scroll', handler, { passive: true })
        win.addEventListener('wheel', handler, { passive: true })
        tosPollInterval = setInterval(() => {
          if (tosAcceptEnabled.value) {
            clearInterval(tosPollInterval)
            return
          }
          try { handler() } catch (e) {}
        }, 200)
        // initial check
        handler()
      } catch (err) {
        // Cross-origin or iframe not ready: fallback timer
        tosFallbackTimer = setTimeout(() => {
          tosAcceptEnabled.value = true
        }, 4000)
      }
    }

    const onTosRadioClick = () => {
      if (tosAccepted.value) return
      if (!tosUrl.value) {
        return showNotif({ status: 'error', message: 'Ketentuan tidak tersedia' })
      }
      tosModal && tosModal.show()
      // re-init detection every time modal is opened
      setupTosDetection()
    }

    const onTosIframeLoad = () => {
      // whenever iframe reloads (if it does), re-init detection
      setupTosDetection()
    }

    const acceptTos = () => {
      tosAccepted.value = true
      tosModal && tosModal.hide()
      // ensure the native radio visually reflects acceptance on close
      nextTick(() => {
        const radio = document.getElementById('tosAgree')
        if (radio) radio.checked = true
      })
    }

    const onTosModalClosed = () => {
      // If user closed modal without accepting, allow reopening by unchecking radio
      if (!tosAccepted.value) {
        const radio = document.getElementById('tosAgree')
        if (radio) radio.checked = false
      }
      if (tosFallbackTimer) clearTimeout(tosFallbackTimer)
      if (tosPollInterval) clearInterval(tosPollInterval)
      tosAcceptEnabled.value = false
    }

    const closePatient = () => {
      if (isPatientForMobileShown.value) {
        router.push({
          query: { showSummary: !isPatientForMobileShown.value }
        })
      }
    }

    const setMyData = () => {
      useMyData.value = true
      // set status periksa diri sendiri
      isSelfPatientPoli.value = 1
    }

    const setSelectMember = () => {
      useMyData.value = false

      // set status periksa orang lain
      isSelfPatientPoli.value = 2
      closePatient()
    }

    const goSelectPoli = () => {
      router.push({ name: 'SelectPoli' })
    }

    const goSelectBranch = () => {
      if (!selectedPoli.value) {
        return showNotif({ status: 'error', message: 'Silakan pilih poli terlebih dahulu' })
      }
      // reset downstream state
      selectedBranchPoli.value = null
      selectedDoctorPoli.value = null
      selectedDoctorSchedulePoli.value = null
      listDoctorSchedulePoli.value = []
      // keep only poli query, drop the rest
      const nextQuery = route.query.poli ? { poli: route.query.poli } : {}
      router.push({ name: 'SelectBranchPoli', query: nextQuery })
    }

    const goSelectDoctor = () => {
      if (!selectedPoli.value) {
        return showNotif({ status: 'error', message: 'Silakan pilih poli terlebih dahulu' })
      }
      if (!selectedBranchPoli.value) {
        return showNotif({ status: 'error', message: 'Silakan pilih cabang terlebih dahulu' })
      }
      // reset downstream state
      selectedDoctorPoli.value = null
      selectedDoctorSchedulePoli.value = null
      listDoctorSchedulePoli.value = []
      // keep only poli and cabang queries, drop the rest
      const nextQuery = {}
      if (route.query.poli) nextQuery.poli = route.query.poli
      if (route.query.cabang) nextQuery.cabang = route.query.cabang
      router.push({ name: 'SelectDoctorPoli', query: nextQuery })
    }

    return {
      user,
      selectedPatientPoli,
      selectedDatePoli,
      selectedPoli,
      selectedBranchPoli,
      selectedDoctorPoli,
      todayYmd,
      loading,
      errorMessage,
      submit,
      total,
      summaries,
      confirmationMessages,
      subTotal,
      dayValue,
      monthValue,
      yearValue,
      openDatePicker,
      datePickerRef,
      useMyData,
      getInitialName,
      isPatientForMobileShown,
      closePatient,
      isMobile,
      setSelectMember,
      setMyData,
      listAnggotaKeluarga,
      goSelectPoli,
      goSelectBranch,
      goSelectDoctor,
      // schedules
      listDoctorSchedulePoli,
      selectedDoctorSchedulePoli,
      availableSchedules: computed(() => (listDoctorSchedulePoli.value || []).filter((s) => s.status === 'AVAILABLE')),
      selectSchedule: (item) => { selectedDoctorSchedulePoli.value = item },
      // tos
      tosAccepted,
      tosAcceptEnabled,
      tosIframeRef,
      onTosRadioClick,
      onTosIframeLoad,
      acceptTos,
      onTosModalClosed,
      tosUrl,
      continueDisabled: computed(() => {
        const requiresTos = !!(selectedDoctorPoli.value && selectedDoctorPoli.value.ketentuan)
        return !selectedDoctorSchedulePoli.value || (requiresTos && !tosAccepted.value) || loading.registerPoli
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-control, .input-group-text {
  background: none;
  border-radius: 0;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.2);
  padding: 8px 4px 8px 0px;
  font-size: 18px;
  border: none;
}

.form-control {
  &.input-note {
    border-radius: 12px;
    padding: 8px 14px;
  }
}

.form-control::placeholder {
  color: #CBD5E0;
}

.form-control.is-invalid, .input-group-text.is-invalid {
  box-shadow: inset 0px -1px 0px #E21F39;
}

.input-group>.form-control.form-error {
  background: #FFDDEB;
  color: #14142B;
}

.initial {
  padding: 9px 8px;
  border-radius: 12px;
  gap: 8px;

  &-wrapper {
    width: 36px;
    height: 36px;
  }

  .value-wrapper {
    gap: 4px;
  }
}

select.select-patient {
  height: 100%;
  font-size: 18px;
  line-height: 24px;
  border: none;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset;
}

.payment-method {
  width: 24px;
  height: 24px;

  &-label:active {
    color: #4A5568;
  }
}

.payment-method:checked {
  accent-color: #007A98;
}

.date-picker-group .month-caret {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #4A5568;
  font-size: 12px;
}

.icon-rect {
  width: 42px;
  height: 42px;
}

.icon-rect img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* ensure skeleton placeholder inside icon-rect is visible */
.icon-rect .placeholder {
  display: block;
  width: 24px;
  height: 24px;
}

/* ensure text line skeletons have visible height */
.poli-skeleton .placeholder-line {
  display: block;
  height: 16px;
  border-radius: 4px;
}

/* skeleton helpers for branch and doctor */
.branch-skeleton .placeholder-line,
.doctor-skeleton .placeholder-line {
  display: block;
  height: 16px;
  border-radius: 4px;
}

.notification {
  padding: 10px;
  border-radius: 12px;

  &-desc {
    @media (max-width: 767px) {
      max-width: 281px;
    }
  }
}

.card-patient {
  border-radius: 10px !important;
  box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.05);
  padding-top: 8px;
  z-index: 100;

  @media (max-width: 767px) {
    position: fixed;
    bottom: 0rem;
    left: 0;
    right: 0;
    transition: all .3s ease-in-out;
    max-height: 80vh;
  }

  @media (min-width: 768px) {
    position: fixed;
    top: 2rem;
    left: 25rem;
    right: 25rem;
    transition: all .3s ease-in-out;
    max-height: 93vh;
  }

  .tab {
    width: 48px;
    height: 4px;
    border-radius: 14px;
  }

  .patient-list {
    padding: 8px 18px 25x;
    border-radius: 20px 20px 0px 0px;

    @media (max-width: 767px) {
      height: 65vh;
      overflow-y: auto;
    }

    .patient-item {
      padding: 12px 18px;
      gap: 8px;
      box-shadow: 0px -1px 0px 0px #F2F2F2CC inset;

      .value-wrapper {
        gap: 4px;
      }

      .btn-wrapper {
        bottom: 0;
      }

      &.active {
        color: white;
        background-color: #8CC63F;
      }
    }

    .patient-wrapper {
      width: 36px;
      height: 36px;
    }
  }
}

.booking-summary {
  @media (max-width: 767px) {
    position: fixed;
    bottom: 0rem;
    left: 0;
    right: 0;
    transition: all .3s ease-in-out;
    max-height: 93vh;
    z-index: 100;
  }

  .card-summary-order {
    border-radius: 10px !important;
    box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.05);
    padding-top: 8px;

    .tab {
      width: 48px;
      height: 4px;
      border-radius: 14px;
    }

    .summary {
      &-list {
        padding: 8px 18px 20px;
        border-radius: 20px 20px 0px 0px;
        overflow-y: auto;

        @media (max-width: 767px) {
          max-height: 80vh;
        }
      }

      &-group {
        @media (max-width: 767px) {
          height: 60vh;
          margin-bottom: 6rem;
        }

        &-location {
          .address-box {
            position: relative;
            padding: 13px 8px;
            border-radius: 12px;
            padding: 8px;

            .icon-wrapper {
              width: 34px;
              height: 34px;

              img {
                width: 18px;
                height: auto;
              }
            }

            &-info {
              &-name {
                font-size: 14px;
                line-height: 24px;
                margin-bottom: 4px;
              }

              &-address {
                font-size: 12px;
                line-height: 14px;
              }
            }
          }
        }

        &-list {
          .service {
            box-shadow: 0px -1px 0px 0px #F2F2F2CC inset;

            &-icon {
              width: 42px;
              height: 42px;
            }

            &-group {
              padding: 12px 0;
            }

            &-title {
              font-size: 14px;
              line-height: 24px;
              margin-bottom: 2px;
            }

            &-price {
              font-size: 12px;
              line-height: 14px;
            }
          }

          .service:last-child {
            box-shadow: unset;
          }
        }

        .recomended-list {
          gap: 4px;

          .recomended-item {
            box-shadow: 0px -1px 0px 0px #F2F2F2CC inset;
            padding: 8px 0;

            &-name {
              font-size: 14px;
              line-height: 24px;
              margin-bottom: 4px;
            }

            &-price {
              font-size: 12px;
              line-height: 14px;
            }
          }

          .recomended-item:last-child {
            box-shadow: unset;
          }
        }
      }
    }

    .action {
      @media (max-width: 767px) {
        background-color: white;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        box-shadow: 0px 1px 0px 0px #F2F2F2CC inset;
      }

      .voucher {
        padding: 11px;
        border-radius: 12px;

        &-icon {
          width: 20px;
          height: 20px;
        }

        &-label {
          font-size: 12px;
          line-height: 22px;
        }

        &-use {
          font-size: 10px;
          line-height: 22px;
        }
      }

      .pay {
        .btn-pay {
          width: 169px !important;

          @media (max-width: 767px) {
            position: absolute;
            right: 20px;
            z-index: 99 !important;
          }
        }

        .btn-pay:focus {
          box-shadow: none;
        }
      }
    }
  }
}

.backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10;
}

/* Branch and Doctor styles to mirror selection items */
.branch {
  box-shadow: 0px -1px 0px 0px #F2F2F2CC inset;

  .icon-wrapper {
    width: 48px;
    height: 48px;
  }

  .branch-group-info {
    gap: 4px;
  }
}

.avatar {
  width: 56px;
  height: 56px;
  border: 2px solid #37C684;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tos-iframe {
  border: none;
  height: 60vh;
}

/* Force perfect circle radio */
.form-check-input-circle[type='radio'] {
  border-radius: 50% !important;
  width: 1rem;
  height: 1rem;
  min-width: 1rem;
  min-height: 1rem;
}
</style>
